import { Injectable } from '@angular/core';
import { observable, action } from 'mobx-angular';
import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { DataService } from 'src/app/services/data.service';
import { orderBy } from 'src/app/services/mapping.service';

@Injectable({
    providedIn: 'root'
})
export class Term {
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable data: Array<any> = [];
    @observable empty: boolean = false;

    subscribe: any = null;
    constructor(private ds: DataService) { }

    @action
    dispost() {
        this.data = [];
        if (this.subscribe) this.subscribe.unsubscribe()
    }

    @action
    fetchData(ref: AngularFirestoreCollection) {
        this.loading = true;
        this.subscribe = ref.valueChanges().subscribe(docs => {
            this.data = orderBy(docs, "fromDateKey");
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    save(ref: AngularFirestoreCollection, item: any, callback) {
        this.process = true;
        ref.doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
